import api from './api';

export async function loadUserAgencies() {
  try {
    const response = await api.get('/rest/agency/loadUsersAgencies');
    return response.data;
  } catch (error) {
    console.error('Error fetching user agencies:', error);
    throw error;
  }
}
